export function getRouteName(state) {
  return state.route.name;
}

export function getRouteParams(state) {
  return state.route.params;
}

export function getRouteQuery(state) {
  return state.route.query;
}



// WEBPACK FOOTER //
// ./src/store/getters.js